import type { NodeBaseModel } from '../models';
import type { SourceModelBase } from '../../custom_shared/models';
import ContractDraftHistory from '../history/ContractDraftHistory';
import ContractDraftOverlay from './ContractDraftOverlay';
import ContractSourceRequests from './ContractSourceRequests';

// Every node in one form graph shares these collaborators from construction.
export default class ContractDraftContext {
    readonly history: ContractDraftHistory;
    readonly drafts: ContractDraftOverlay;
    readonly sourceRequests: ContractSourceRequests;

    constructor(nodes: () => NodeBaseModel[], sources: () => SourceModelBase[]) {
        this.history = new ContractDraftHistory(nodes);
        this.sourceRequests = new ContractSourceRequests(nodes);
        this.drafts = new ContractDraftOverlay(nodes, this.history, this.sourceRequests, sources);
    }
}
